import { render, staticRenderFns } from "./VIPCube.vue?vue&type=template&id=2e404f84&scoped=true&"
import script from "./VIPCube.vue?vue&type=script&lang=js&"
export * from "./VIPCube.vue?vue&type=script&lang=js&"
import style0 from "./VIPCube.vue?vue&type=style&index=0&id=2e404f84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e404f84",
  null
  
)

export default component.exports